import { useCallback, useRef } from 'react';
import { useEventCallback } from './use-event-callback';
import { useEventListener } from './use-event-listener';

export function useOnKeyDown<T extends HTMLElement = HTMLElement>(
  handler: (event: KeyboardEvent) => void,
  keys: KeyboardEvent['key'][] | KeyboardEvent['key'],
) {
  const ref = useRef<T>(null);
  const callback = useEventCallback(handler);

  const listener = useCallback(
    (event: KeyboardEvent) => {
      const keysArr = Array.isArray(keys) ? keys : [keys];
      const isActive = ref.current !== null ? ref.current.contains(document.activeElement) : true;
      if (keysArr.includes(event.key) && isActive) {
        callback(event);
      }
    },
    [callback, keys],
  );

  useEventListener('keydown', listener, ref);

  return ref;
}
